import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { AdvisorWizardManagerPermissionKeys, AdvisorWizardPermissionKeys, DBDef_AdvisorWizard } from '@app/advisor-content-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
export const dispatch_onAdvisorWizardsUpdated = new ThunderDispatcherV3('__onAdvisorWizardsUpdated');
export class ModuleFE_AdvisorWizard_Class extends ModuleFE_BaseApi {
    _v1;
    permissions;
    constructor() {
        super(DBDef_AdvisorWizard, dispatch_onAdvisorWizardsUpdated);
        this._v1 = {};
        this.permissions = {
            ui: PermissionKey_FE.generatePermissionKeysByLevels(AdvisorWizardManagerPermissionKeys),
            collection: PermissionKey_FE.generatePermissionKeysByLevels(AdvisorWizardPermissionKeys),
        };
    }
    __searchFilterMapper = (item) => {
        const stepLabels = item.steps.map(step => step.label);
        return [item.label, ...stepLabels];
    };
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey, results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label
                }))
            }];
    };
}
export const ModuleFE_AdvisorWizard = new ModuleFE_AdvisorWizard_Class();
//# sourceMappingURL=ModuleFE_AdvisorWizard.js.map